var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.termsConfig.show)?_c('div',[(_vm.termsConfig.required)?_c('Checkbox',{attrs:{"label":_vm.termsConfig.label},model:{value:(_vm.accepted),callback:function ($$v) {_vm.accepted=$$v},expression:"accepted"}}):_c('span',{style:({ 'font-size': '15px' }),domProps:{"innerHTML":_vm._s(_vm.termsConfig.label)}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }